<template>
  <div
    v-if="platformAttributes && platformAttributes.length > 0"
    class="panel panel-default panel-fill"
  >
    <div class="panel-heading">
      <h3 class="panel-title">
        {{ trans("general.additionalInfo") }}
      </h3>
    </div>
    <div class="panel-body">
      <div class="row">
        <div
          v-for="attribute in platformAttributes"
          :key="attribute.id"
          class="m-b-20 col-md-6"
        >
          <div class="form-group" :class="{ 'has-error': getError(attribute) }">
            <label :for="attribute.name">
              {{ trans(attribute.name) }}
            </label>
            <i v-if="isRequired(attribute)" class="far fa-asterisk" />

            <template v-if="component(attribute) === 'text'">
              <input
                v-model="platformAttributeValues[attribute.name]"
                type="text"
                :name="'platformAttributes[' + attribute.name + ']'"
                class="form-control"
                :placeholder="trans(attribute.name)"
                :required="isRequired(attribute)"
                :minlength="getValidation(attribute, 'min')"
                :maxlength="getValidation(attribute, 'max')"
              />
            </template>

            <template v-else-if="component(attribute) === 'longtext'">
              <textarea
                v-model="platformAttributeValues[attribute.name]"
                :name="'platformAttributes[' + attribute.name + ']'"
                class="form-control"
                :placeholder="trans(attribute.name)"
                :required="isRequired(attribute)"
                :minlength="getValidation(attribute, 'min')"
                :maxlength="getValidation(attribute, 'max')"
              />
            </template>

            <form-error
              v-if="getError(attribute)"
              :errors="getError(attribute)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    platformAttributes: {
      type: Array,
      default: () => [],
    },
    platformAttributeValues: {
      type: Object,
      default: () => ({}),
    },
    platform: {
      type: String,
      default: "",
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    platformAttributes() {
      this.applyDefaults();
    },
  },
  created() {
    this.applyDefaults();
  },
  methods: {
    applyDefaults() {
      if (
        !Array.isArray(this.platformAttributes) ||
        !this.platformAttributeValues
      )
        return;
      for (const attribute of this.platformAttributes) {
        const defaultValue = attribute?.config?.default;
        if (defaultValue && !this.platformAttributeValues[attribute.name]) {
          this.platformAttributeValues[attribute.name] = defaultValue;
        }
      }
    },
    component(attribute) {
      return attribute?.config?.ui?.component || "text";
    },
    isRequired(attribute) {
      return attribute?.config?.validation?.required === true;
    },
    getValidation(attribute, key) {
      return attribute?.config?.validation?.[key] ?? null;
    },
    getError(attribute) {
      const parts = attribute.name.split(".");
      let obj = this.errors;
      for (const part of parts) {
        obj = obj?.[part];
      }
      return obj || null;
    },
  },
};
</script>
